module.exports = __webpack_public_path__ + "img/investment-not-found.6c1ea067.svg";